import { Alert, Button, Col, Modal, ModalHeader, ModalBody, ModalFooter, Nav, NavItem, NavLink, Row, Label, FormFeedback, Form, Input, FormGroup, Spinner } from 'reactstrap'
import Select from 'react-select'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import { selectThemeColors, myDateFormat } from '../../../utility/Utils'
import { Trash } from 'react-feather'
import { selectProfile, setLoader, setProfileLoader, updatePersonalDetails } from './store'
import React, { useEffect, useState } from 'react'
// ** Styles Imports
import Flatpickr from 'react-flatpickr'
import '@styles/react/libs/react-select/_react-select.scss'
import '@styles/react/libs/flatpickr/flatpickr.scss'
import { handleDecimal } from '../../components/modal/modalSubComponet'

const PersonalForm = ({ toggle }) => {
  const [DOBPicker, setDOBPicker] = useState(new Date())
  const { myProfile, loader,profileLoader } = useSelector((store) => store?.MyProfile)

  const dispatch = useDispatch()
  const {
    reset,
    control,
    setError,
    setValue,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({})
  const [file, setFile] = useState()

  const [leveCount, setLeveCount] = useState(0)

  const [fileDeleted, setFileDeleted] = useState(false)
  const [active, setActive] = useState(true)
  const [gstActive, setgstActive] = useState(false)
  const setMyActiveMode = (data) => {
    setActive(!active)
  }

  const genderOption = [{ label: 'Male', value: 'Mr' }, { label: 'Female', value: 'Mrs' }, { label: 'Other', value: 'Other' }]
  const nominee_relation = [{ label: 'Spouse', value: 'Spouse' }, { label: 'Son', value: 'Son' }, { label: 'Daughter', value: 'Daughter' }, { label: 'Mother', value: 'Mother' }, { label: 'Father', value: 'Father' }]

  const handleDiscard = () => {
    toggle()
  }

  console.log('Modal', myProfile)

  const onSubmit = async (data) => {
    
    let response = ""
    let formData = new FormData()
    if (myProfile !== null) {
      formData.append('gender', data.name_prefix.value === 'Mr' ? 'Male':'Female')
      formData.append('name_prefix', data.name_prefix.value)
      formData.append('Email', data.Email)
      formData.append('address', data.address)
      formData.append('zipcode', data.zipcode)
      formData.append('nominee_relation', data?.nominee_relation?.value ?? '')
      formData.append('nominee_name', data?.nomineeName ?? '')
      !gstActive && formData.append('gst_number', data?.gstnumber ?? '')
      formData.append('dob', myDateFormat(DOBPicker,'YYYY-MM-DD'))
      formData.append('profile_image', file)
    }
    
    dispatch(setLoader(true));
    response = await dispatch(
      updatePersonalDetails(formData)
    )
    if (response) {
      handleDiscard()
  }
  }
  
  useEffect(() => {
    dispatch(setLoader(false));
    if (myProfile) {
      let genderObj = {}
      genderOption.forEach((e) => {
        if (e.value == myProfile?.name_prefix) {
          genderObj = {
            label: e?.label,
            value: e?.value
          }
        }
      })

      let nomineeObj = {}
      nominee_relation.forEach((e) => {
        if (e.value == myProfile?.nominee_relation) {
          nomineeObj = {
            label: e?.label,
            value: e?.value
          }
        }
      })

      
      setValue('name_prefix', genderObj)
      setValue('nominee_relation', nomineeObj)
      setValue('Name', myProfile.Name)
      setValue('Email', myProfile.Email)
      setValue('dob', setDOBPicker(new Date(myProfile.dob)))
      setValue('address', myProfile.address)
      setValue('zipcode', myProfile.zipcode)
      setValue('Phone', myProfile.Phone)
      setValue('profile_image', myProfile.profile_image)
      setValue('nomineeName', myProfile.nominee_name)
      setValue('gstnumber', myProfile.gst_number)
      myProfile?.gst_number && setgstActive(true)
    }
  }, [myProfile])

  //Handle the uploaded file
  const handleFile = (e) => {
    setValue('profile_image', e.target.files[0])
    setFile(e.target?.files[0])
    console.log('e.target?.files[0]', e.target?.files[0])
  }
  
  return (
    <Form onSubmit={handleSubmit((data) => onSubmit(data, 'Add'))}>
      <Row >
        <Col sm="6" className="mb-1" display="flex">

          <Label className="form-label" for="Name">
            Name
          </Label>
          <Controller
            name="Name"
            control={control}
            {...register('Name', {
              required: 'Please Enter Name'
            })}
            render={({ field }) => (
              <Input
                placeholder="Name"
                id="Name"
                invalid={errors.Name && true}
                {...field}
                disabled
              />
            )}
          />
          {errors && errors.Name && (
            <FormFeedback>{errors.Name.message}</FormFeedback>
          )}
        </Col>
        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="Email">
            Email
          </Label>
          <Controller
            name="Email"
            control={control}
            {...register('Email', {
              required: 'Please Enter Email',
              pattern:{
                value: /\S+@\S+\.\S+/,
                message:'In-valid E-mail'
              }
            })}
            render={({ field }) => (
              <Input
                placeholder="Email"
                id="Email"
                type='email'
                invalid={errors.Email && true}
                // disabled
                {...field}
              />
            )}
          />
          {errors && errors.Email && (
            <FormFeedback>{errors.Email.message}</FormFeedback>
          )}
        </Col>
        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="name_prefix">
            Name Prefix
          </Label>
          <Controller
            id="name_prefix"
            name="name_prefix"
            control={control}
            rules={{ required: 'Please select name prefix' }}
            invalid={errors.name_prefix && true}
            render={({ field }) => (
              <Select
                isClearable={false}
                placeholder="Select"
                classNamePrefix="select"
                options={genderOption}
                theme={selectThemeColors}
                className={classNames('react-select', {
                  'is-invalid': errors.name_prefix
                })}
                {...field}
              />
            )}
          />
          {errors && errors.name_prefix && (
            <FormFeedback>{errors.name_prefix.message}</FormFeedback>
          )}
        </Col>
        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="Phone">
            Phone
          </Label>
          <Controller
            name="Phone"
            control={control}
            {...register('Phone', {
              required: 'Please Enter Phone'
            })}
            render={({ field }) => (
              <Input
                placeholder="Phone"
                id="Phone"
                invalid={errors.Phone && true}
                disabled
                {...field}
              />
            )}
          />
          {errors && errors.Phone && (
            <FormFeedback>{errors.Phone.message}</FormFeedback>
          )}
        </Col>
        <Col sm="6" display="flex" className="mb-1">
          <Label className='form-label' for='dob'>
            DOB
          </Label>
          <Flatpickr
            required
            id='dob'
            name='dob'
            className='form-control'
            onChange={date => setDOBPicker(date[0])}
            value={DOBPicker}
            options={{
              //   enableTime: allDay === false,
              dateFormat: 'Y-m-d'
            }}
          />
          {errors && errors.dob && (
            <FormFeedback>{errors.dob.message}</FormFeedback>
          )}
        </Col>

        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="address">
            Address
          </Label>
          <Controller
            name="address"
            control={control}
            {...register('address', {
              required: 'Please Enter Address',
              pattern: {
                // value: /^[a-zA-Z0-9\s,]*$/,
                message: 'Please enter a valid address without special characters',
              },
            })}
            render={({ field }) => (
              <Input
                placeholder="Enter Address"
                id="address"
                invalid={errors.address && true}
                {...field}
              />
            )}
          />
          {errors && errors.address && (
            <FormFeedback>{errors.address.message}</FormFeedback>
          )}
        </Col>


        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="zipcode">
            PIN Code
          </Label>
          <Controller
            name="zipcode"
            control={control}
            {...register('zipcode', {
              required: 'Please Enter PIN Code',
              pattern: {
                value: /^[1-9][0-9]{5}$/,
                message: 'Please enter a valid Indian PIN Code',
              },
            })}
            render={({ field }) => (
              <Input
                placeholder="Enter PIN Code"
                id="zipcode"
                invalid={errors.zipcode && true}
                {...field}
                onKeyPress={(e)=>handleDecimal(e,'number')}
              />
            )}
          />
          {errors && errors.zipcode && (
            <FormFeedback>{errors.zipcode.message}</FormFeedback>
          )}
        </Col>


        <Col sm={6} className="mb-1">
          <Label className="form-label" for="profile_image">
            Upload profile_image
          </Label>
          <Controller
            id="profile_image"
            name="profile_image"
            control={control}
            render={({ field }) => (
              <Input
                id="profile_image"
                type="file"
                name="profile_image"
                invalid={errors.profile_image && true}
                onChange={handleFile}
                files={file}
              />
            )}
          />
          {errors && errors.profile_image && (
            <FormFeedback>{errors.profile_image.message}</FormFeedback>
          )}
        </Col>

        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="zipcode">
           Nominee Name
          </Label>
          <Controller
            name="nomineeName"
            control={control}
            {...register('nomineeName', {
              required: false,
            })}
            render={({ field }) => (
              <Input
                placeholder="Please Enter nominee name"
                id="nomineeName"
                invalid={errors.nomineeName && true}
                {...field}
              />
            )}
          />
          {errors && errors.nomineeName && (
            <FormFeedback>{errors.nomineeName.message}</FormFeedback>
          )}
        </Col>

        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="name_prefix">
          Nominee  Relation
          </Label>
          <Controller
            id="nominee_relation"
            name="nominee_relation"
            control={control}
            rules={{ required: false }}
            invalid={errors.nominee_relation && true}
            render={({ field }) => (
              <Select
                isClearable={false}
                placeholder="Select"
                classNamePrefix="select"
                options={nominee_relation}
                theme={selectThemeColors}
                className={classNames('react-select', {
                  'is-invalid': errors.name_prefix
                })}
                {...field}
              />
            )}
          />
          {errors && errors.name_prefix && (
            <FormFeedback>{errors.nominee_relation.message}</FormFeedback>
          )}
        </Col>

        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="zipcode">
            GST number 
          </Label>
          <Controller
            name="gstnumber"
            control={control}
            {...register('gstnumber', {
              required: false,
            })}
            render={({ field }) => (
              <Input
                placeholder="Please Enter gst number"
                id="gstnumber"
                invalid={errors.gstnumber && true}
                disabled={gstActive}                
                {...field}
              />
            )}
          />
          {errors && errors.gstnumber && (
            <FormFeedback>{errors.gstnumber.message}</FormFeedback>
          )}
        </Col>
        <Col xs={12} className="text-center buttonWrapper mt-2">
          <Button className="me-1" color="primary" type="submit" disabled={loader}
          >
            {loader ? (
              <Spinner text="Loading..." color="white" size="sm" />
            ) : (
              'Add'
            )}
          </Button>
          <Button outline type="reset" onClick={handleDiscard}>
            Discard
          </Button>
        </Col>
      </Row>
    </Form>
  )
}
export default PersonalForm